import { gql } from '@apollo/client';

export const ACCOUNT_SETTINGS = gql`
  query AccountSettings {
    currentUser {
      id
      name
      email
      phoneNumber
      address
      city
      postalCode
      about
      avatarImageUrl
      notificationSetting {
        emailEnabled
        pushEnabled
        marketingEnabled
      }
    }
  }
`;
